import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import axiosInstance from "../../../axios";


const AdminTableData = () => {
  const [tableData, setTableData] = useState({});
  const history = useHistory();
  const courseStatics = [
    {
      name: "Instructor with Email Verification Pending",
      total: tableData?.pendingVerification,
      lastUpdate: "05-12-22",
      action: "/dashboard/instructorList",
    },
    {
      name: "Instructor with Published Course",
      total: tableData?.withPublishedCourse,
      lastUpdate: "28-11-22",
      action: "/dashboard/instructorList",
    },
    {
      name: "Instructor with Course Not Published",
      total: tableData?.withNotPublishedCourse,
      lastUpdate: "03-12-22",
      action: "/dashboard/instructorList",
    },
    {
      name: "Total No. of Courses in Draft ",
      total: tableData?.totalDraftCourse,
      lastUpdate: "04-12-22",
      action: "/dashboard/Course",
    },
  ];
  const fetch = () => {
    axiosInstance
      .get("admin/instructor-statistics")
      .then((res) => {
        setTableData(res?.data?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    fetch();
  }, []);
  return (
    <div className="margin-top-new-01">
      <div className="box-shadow-new-01">
        <p className="paragraph-css">Instructor and Courses Statistics</p>
        <div>
          <table className="table-width-100">
            <thead>
              <tr>
                <td></td>
                <td></td>
                <td>Last Update</td>
                <td>Action</td>
              </tr>
            </thead>
            <tbody>
              {courseStatics.map((item, index) => (
                <tr key={index}>
                  <td className="cell">{item.name}</td>
                  <td className="cell">
                    {item.total ? (
                      item.total
                    ) : "..."}
                  </td>
                  <td className="cell">{item.lastUpdate}</td>
                  <td className="cell">
                    <img
                      className="img-link-new"
                      src="https://www.pngfind.com/pngs/m/683-6838012_transparent-link-clipart-external-link-icon-white-hd.png"
                      onClick={()=>{history.push(item.action)}}
                    ></img>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AdminTableData;
